import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse } from 'src/app/_services/app.service';
import { LoginComponent } from '../login/login.component';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

  resetPassword: PasswordForm;
  isPasswordVisible: boolean = false;

  // tslint:disable-next-line: max-line-length
  constructor(private service: AppService, private translate: TranslateService, @Inject('BASE_URL') private baseUrl: string, @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, public dialogRef: MatDialogRef<LoginComponent>) { }

  ngOnInit() {
    this.InitializeForm();
  }

  /** Initializes the form values */
  InitializeForm() {
    this.resetPassword = {
      currentPassword: '',
      newConfirmPassword: '',
      newPassword: '',
      userId: this.data.userId
    };
  }

  /** Submit button event */
  OnSubmitClick() {
    if (this.resetPassword.newPassword && this.resetPassword.newConfirmPassword) {
      this.service.showSpinner();
      this.http.post<GRSSResponse>(this.baseUrl + 'api/auth/changePasswordAuth', this.resetPassword).subscribe( result => {
        let message = this.translate.instant(result.statusMessage);
        if (result.statusCode === 1) {
          message += '<br>' + this.translate.instant('Auth.Messages.msgSuccessLogAgain');
        }
        this.service.SaveStatus(false, this.translate.instant('Auth.Messages.msgHeaderLogin'), message, true);
        if (result.statusCode === 1) {
          this.dialogRef.close();
        }
      }, error => {
        console.error(error);
      }).add(() => {
        this.service.hideSpinner();
      });
    }
  }

}

/** Interface to access values in the password form */
interface PasswordForm {
  userId: string;
  currentPassword: string;
  newPassword: string;
  newConfirmPassword: string;
}
